import React, { useEffect, useState } from 'react'
import DashboardContainer from '../../components/dashboard-container'
import CircularProgress from '@mui/material/CircularProgress'
import { Box } from '@mui/material'
import CustomPagination from '../../components/pagination'
import ShippingServiceMapModal from '../../components/shipping-service-map-modal'
import { shippingServiceMapService } from '../../utils/services/shippingServiceMapService'
import ShippingServiceMapList from '../../components/shipping-service-map-list'

export default function ShippingServiceMap() {
  const [shippingServiceMapData, setShippingServiceMapData] = useState([])
  const [selectedService, setSelectedService] = useState(null)
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(15)
  const [dataCount, setDataCount] = useState(rowsPerPage)
  const [openModal, setOpenModal] = useState(false)
  const [selectedClient, setSelectedClient] = useState({ name: '' })
  const [searchValue, setSearchValue] = useState('')
  const [clientFilter, setClientFilter] = useState(null)
  const clientId = localStorage.getItem('client_id')
  const [viewMode, setViewMode] = useState('list')

  const fetchShippingServiceMapData = async () => {
    setLoading(true)
    try {
      const skip = page * rowsPerPage
      const response = await shippingServiceMapService.fetch(
        rowsPerPage,
        skip,
        clientId ? clientId : clientFilter?._id,
        searchValue
      )
      setShippingServiceMapData(response.data)
      setDataCount(response?.total)
    } catch (error) {
      console.error('Fetch failed:', error)
      // Handle fetch failure
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    fetchShippingServiceMapData()
  }, [page, rowsPerPage, clientFilter, searchValue])

  const NoDataImage = () => (
    <div
      style={{
        width: '100%',
        justifyContent: 'center',
        display: 'flex'
      }}
    >
      <img src="no_data.png" alt="No data available" style={{ objectFit: 'cover', height: '340px' }} />
    </div>
  )

  return (
    <DashboardContainer
      filterButton={false}
      searchBarPlaceholder={'Search by service'}
      hideFilterClient
      onSearchData={(x) => {
        setSearchValue(x)
        setPage(0)
      }}
      onClickAddButton={() => setOpenModal(true)}
      hideUploadButton={true}
      header={'Shipping Service Map List'}
      onSelectClient={(e) => {
        setClientFilter(e)
      }}
      selectedClient={selectedClient?.name}
      title={'+ Shipping Service Map'}
      setViewMode={setViewMode}
    >
      <ShippingServiceMapModal
        selectedService={selectedService}
        handleClose={() => {
          setOpenModal(false)
          setSelectedService(null)
        }}
        open={openModal}
        onAddData={fetchShippingServiceMapData}
      />

      {loading && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 9999,
            color: 'white'
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
      )}

      {shippingServiceMapData.length === 0 ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%'
          }}
        >
          <NoDataImage />
        </div>
      ) : (
        <ShippingServiceMapList
          onDeleteData={() => fetchShippingServiceMapData()}
          onEditData={(e) => {
            setSelectedService(e)
            setOpenModal(true)
          }}
          data={shippingServiceMapData}
          viewMode={viewMode}
          deleteTitle={'Delete Port'}
          selectedService={selectedService}
          setSelectedShippingService={setSelectedService}
          currentPage={page}
          itemsPerPage={rowsPerPage}
        />
      )}

      <CustomPagination
        dataCount={dataCount}
        rowsPerPage={rowsPerPage}
        page={page}
        setPage={setPage}
        setRowsPerPage={setRowsPerPage}
        disableNext={dataCount <= rowsPerPage * (page + 1)}
      />
    </DashboardContainer>
  )
}
